import firebase from "firebase/app";
import "firebase/firestore";

export const getQuestions = () => {
  return firebase
    .firestore()
    .collection("ask")
    .orderBy("createDate", "desc");
};

export const submitQuestion = payload => {
  return firebase
    .firestore()
    .collection("ask")
    .add(payload);
};
